type HttpErrorProps<T = any> = {
  statusCode?: number;
  message: string;
  data?: T;
};

export class HttpError<T = any> extends Error {
  statusCode?: number;
  data?: T;

  constructor({ statusCode: code, data, message }: HttpErrorProps<T>) {
    super(message);

    this.statusCode = code;
    this.data = data;
  }
}
